var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStripeinline = function SvgStripeinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#635BFF",
    rx: 3.259
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M8.23 5.29c-.593 0-.951.17-.951.615 0 1.276 4.266.672 4.277 4.068 0 2.04-1.601 3.214-3.93 3.214a7.65 7.65 0 0 1-3.057-.65V9.825c.94.524 2.127.912 3.057.912.627 0 1.075-.171 1.075-.696 0-1.356-4.256-.854-4.256-4 0-2.017 1.512-3.225 3.785-3.225.93 0 1.848.149 2.778.525v2.678c-.851-.468-1.926-.73-2.778-.73"
  })));
};
export default SvgStripeinline;